var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"id":"header"}},[_c('div',{staticClass:"header-logo"},[_c('img',{attrs:{"src":_vm.designPathCreate(_vm.logoUri),"alt":_vm.logoAltText}})])])}
var staticRenderFns = []

export { render, staticRenderFns }